/* eslint-disable max-len */

export default class AutoComplete {
    /**
      * @param {string} search
      * @param {string} matchList
      */

    constructor({ search = 'helpSearchBox', matchList = 'match-list' } = {}) {
        this.searchId = search;
        this.matchListId = matchList;
        this.init();
    }

    async init() {
        this.search = document.getElementById(this.searchId);
        if (!this.search) {
            return;
        }
        this.matchList = document.getElementById(this.matchListId);
        this.timeout = null;
        this.outSideClick = null;
        this.search.addEventListener('input', () => {
            if (this.outSideClick == null) {
                this.outsideClick = true;
                document.addEventListener('click', this.outsideClickListener, true);
            }
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => { this.searchStates(this.search.value); }, 500);
        });

        this.form = this.search.closest('form');
        this.form.addEventListener('submit', () => {
            this.search.style.color = 'transparent';
            this.search.value = this.search.value.replace(/\+/, '_plus_');
        });
    }

    outsideClickListener = (event) => {
       if (event.target.id !== 'match-list') {
           this.matchList.innerHTML = '';
           this.matchList.classList.remove('card');
       }
    }

    searchStates(rawSearchText) {
        const searchText = rawSearchText.replace(/\+/, '_plus_');
        if (searchText === '') {
            this.matchList.innerHTML = '';
            this.matchList.classList.remove('card');
            return;
        }

        fetch(`/help/auto-complete-search/${encodeURIComponent(searchText)}`, {
                   method: 'GET',
                   mode: 'cors',
                   cache: 'no-cache',
                   headers: {
                       'Content-Type': 'application/json',
                    },
            }).then((response) => response.json()).then((data) => {
                this.outputHtml(data);
         });
     }

    outputHtml(matches) {
        if (matches.length > 0) {
            this.matchList.classList.add('card');
            const htmlstartList = '<ul>';
            const html = matches.map((match, i) => `<li><a href="${match.url}"><div class="card__content"><strong>${match.name}</strong> ${matches[i + 1] ? '' : '<svg viewBox="0 0 16 16" class="stadium-access-info-list__arrow-icon" role="presentation" aria-hidden="true"><use xlink:href="#icon-arrow-right"/></svg>'}</div></a></li>`).join('');
            const htmlEndList = '</ul>';
            this.matchList.innerHTML = `${htmlstartList}${html}${htmlEndList}`;
        }
    }
}
